<template>
  <section class="landing-page">
    <Header />
    <MainInfo currentCard="Website Color Palette" />
    <Pricing />
    <ProductHunt />
    <Footer />

    <section class="hunt"></section>

    <footer class="footer"></footer>
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import MainInfo from "@/components/comparison/MainInfo";
import Pricing from "@/components/landing/Pricing";
import ProductHunt from "@/components/landing/ProductHunt";
import Footer from "@/components/landing/Footer";
import {updateMetaTag, updateCanonical} from "@/utils/useHeadUtils"

export default {
  components: {
    Header,
    MainInfo,
    Pricing,
    ProductHunt,
    Footer,
  },
  mounted() {
    const title = 'Site Palette vs. Website Color Palette: Why Site Palette is the Best Choice for Designers';
    const description = 'Discover the key differences between Site Palette and Website Color Palette, and learn why professional designers prefer Site Palette for creating cohesive, visually appealing websites.';

    document.title = title;
    updateMetaTag('twitter:title', title);
    updateMetaTag('description', description);
    updateMetaTag('twitter:description', description);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateCanonical('https://palette.site/vs-website');
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.landing-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
